// Zeigt ein Geheimnis (Bot-Key / generiertes Passwort) — wird nur EINMAL
// angezeigt, mit Kopier-Knopf + Warnung.

import { useState } from "react";

export function SecretBox({
  title,
  secret,
  onDismiss,
}: {
  title: string;
  secret: string;
  onDismiss: () => void;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
    } catch {
      /* Clipboard nicht verfügbar — Nutzer kopiert manuell */
    }
  }

  return (
    <div className="op-secret">
      <div className="op-secret-title">⚠️ {title}</div>
      <p className="op-secret-hint">
        Wird <strong>nur einmal</strong> angezeigt — jetzt sicher kopieren und an
        die Kanzlei übergeben (nicht per E-Mail).
      </p>
      <code className="op-secret-value">{secret}</code>
      <div className="op-secret-actions">
        <button type="button" className="op-btn-ghost" onClick={copy}>
          {copied ? "Kopiert ✓" : "Kopieren"}
        </button>
        <button type="button" className="op-btn-ghost" onClick={onDismiss}>
          Schließen
        </button>
      </div>
    </div>
  );
}
